<template>
  <div class="timeline-item">
    <div
      class="timeline-item__icon-block"
      :class="{ 'timeline-item__icon-block_side-line': withSideline }"
    >
      <div
        class="timeline-item__icon-wrapper"
        :class="{ 'timeline-item__icon-wrapper_side-line': withSideline }"
      >
        <div
          v-if="withSideline"
          class="timeline-item__line-before-icon"
          :style="{ background: data?.icon?.color }"
        />
        <slot name="icon">
          <component
            :is="data.icon.svg"
            v-if="data.icon?.svg"
            class="timeline-item__icon"
            :class="{ 'timeline-item__icon_side-line': withSideline }"
            :style="{ color: data.icon.color || '' }"
          />
        </slot>
      </div>

      <div
        v-if="withLine"
        class="timeline-item__icon-line"
        :class="{ 'timeline-item__icon-line_side-line': withSideline }"
        :style="{ borderLeft: `1px solid ${lineColor}` }"
      />
      <div
        v-if="withSideline"
        class="timeline-item__icon-line"
        :class="{
          'timeline-item__icon-line_side-line': withSideline,
          'timeline-item__icon-line_bottom-line': !!data.nextColor
        }"
        :style="{ borderLeft: `1px solid ${lineColor}` }"
      />
    </div>
    <slot name="content">
      <TimelineItemContent :data="data">
        <template #header>
          <slot name="header" />
        </template>
        <template #text>
          <slot name="text" />
        </template>
      </TimelineItemContent>
    </slot>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  PropType,
  computed,
} from 'vue';

import useAppTheme from '@/composables/application/useAppTheme';

import TimelineItemContent from './components/TimelineItemContent/index.vue';
import { TTimelineItem } from '../../types';

const { getThemeConfig } = useAppTheme();
const { jsColors } = getThemeConfig();

export default defineComponent({
  name: 'TimelineItem',
  components: { TimelineItemContent },
  props: {
    data: {
      type: Object as PropType<TTimelineItem>,
      required: true,
    },
    withLine: {
      type: Boolean,
      default: true,
    },
    lineColor: {
      type: String,
      default: jsColors.neutral60,
    },
    withSideline: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const iconClass = computed(() => (props.data.icon ? `timeline-item__icon-dot_${props.data.icon}` : ''));

    return { iconClass };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
